import { Text } from '@chakra-ui/react';

import { SharedRichTextProps } from './shared-rich-text-props.type';

export const RichTextParagraph = ({ children }: SharedRichTextProps) => (
  <Text sx={{ breakInside: 'avoid' }} textAlign="justify" textStyle="body">
    {children}
  </Text>
);
